<template>
  <div>
    <el-row class="margin-top">
      <el-col :span="24">
        <!-- 按费用名称分组显示 -->
        <div v-for="(group, gIdx) in hisFeeGroups" :key="'his_' + gIdx" class="fee-group">
          <div class="group-title">{{ group.feeName }}（{{ group.fees.length }}条）</div>
          <el-table
            :data="group.fees"
            style="width: 100%"
            border
            stripe
            size="mini"
          >
          <el-table-column prop="feeName" :label="$t('simplifyHisFee.feeItem')" align="center" min-width="100" />
          <el-table-column prop="payerObjName" :label="$t('simplifyHisFee.payerObject')" align="center" min-width="100" />
          <el-table-column :label="$t('simplifyHisFee.receiptNumber')" align="center" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.receiptCode">{{ scope.row.receiptCode }}</div>
              <div v-else>
                <el-link
                  v-if="scope.row.state === '1400'"
                  type="primary"
                  @click="_openGeneratorReceiptCode(scope.row)"
                >
                  {{ $t('simplifyHisFee.manualGenerate') }}
                </el-link>
                <span v-else>-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="cycles" :label="$t('simplifyHisFee.cycle')" align="center" width="60" />
          <el-table-column :label="$t('simplifyHisFee.receivableReceived')" align="center" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.state === '1500'">
                {{ scope.row.payerObjName }}{{ $t('simplifyHisFee.viewInFee') }}
              </div>
              <div v-else>
                {{ scope.row.receivableAmount }}/{{ scope.row.receivedAmount }}<br>
                <div v-if="scope.row.acctAmount > 0">
                  {{ $t('simplifyHisFee.accountDeduction') }}: {{ scope.row.acctAmount }}<br>
                </div>
                <div
                  v-for="(item, index) in scope.row.payFeeDetailDiscountDtoList"
                  :key="index"
                >
                  {{ item.discountName }}: {{ Math.abs(item.discountPrice) }}<br>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="primeRateName" :label="$t('simplifyHisFee.paymentMethod')" align="center" width="90" />
          <el-table-column :label="$t('simplifyHisFee.paymentPeriod')" align="center" min-width="110">
            <template slot-scope="scope">
              {{ formatDate(scope.row.startTime) }}~<br>
              {{ formatDate(scope.row.endTime) }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('simplifyHisFee.paymentTime')" align="center" width="100">
            <template slot-scope="scope">
              {{ (scope.row.createTime || '').substring(0, 10) }}
            </template>
          </el-table-column>
          <el-table-column prop="cashierName" :label="$t('simplifyHisFee.cashier')" align="center" width="80">
            <template slot-scope="scope">
              {{ scope.row.cashierName || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="stateName" :label="$t('simplifyHisFee.status')" align="center" width="70" />
          <el-table-column prop="remark" :label="$t('simplifyHisFee.remark')" align="center" min-width="80" />
          <el-table-column :label="$t('simplifyHisFee.operation')" align="center" width="80">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                plain
                @click="_toHisFeeDetail(scope.row)"
              >
                {{ $t('simplifyHisFee.detail') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        </div>
        <div v-if="hisFeeGroups.length === 0" class="no-data-tip">暂无缴费历史</div>
      </el-col>
    </el-row>

    <el-dialog
      :title="$t('simplifyHisFee.generateReceipt')"
      :visible.sync="receiptDialogVisible"
      width="50%"
    >
      <el-form label-position="left" label-width="120px">
        <el-form-item :label="$t('simplifyHisFee.receiptNumber')">
          <el-select
            v-model="simplifyHisFeeInfo.receiptType"
            class="w-100"
            :placeholder="$t('simplifyHisFee.receiptNumberRequired')"
          >
            <el-option disabled value="">{{ $t('simplifyHisFee.receiptNumberRequired') }}</el-option>
            <el-option value="Y" :label="$t('simplifyHisFee.systemGenerate')"></el-option>
            <el-option value="N" :label="$t('simplifyHisFee.custom')"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="simplifyHisFeeInfo.receiptType === 'N'"
          :label="$t('simplifyHisFee.receiptNumber')"
        >
          <el-input
            v-model="simplifyHisFeeInfo.receiptCode"
            :placeholder="$t('simplifyHisFee.receiptNumberRequired')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="receiptDialogVisible = false">{{ $t('simplifyHisFee.cancel') }}</el-button>
        <el-button type="primary" @click="_generatorReceiptCode">{{ $t('simplifyHisFee.generate') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { queryFeeDetail, generatorReceipt } from '@/api/fee/simplifyHisFeeApi'
import { queryOwnerCars } from '@/api/simplify/simplifyCarFeeApi'
import { getCommunityId } from '@/api/community/communityApi'
import { dateFormat } from '@/utils/dateUtil'

export default {
  name: 'SimplifyHisFee',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 500,
      receiptDialogVisible: false,
      simplifyHisFeeInfo: {
        feeDetails: [],
        ownerId: '',
        roomId: '',
        feeDetail: {},
        receiptType: 'Y',
        receiptCode: ''
      }
    }
  },
  computed: {
    hisFeeGroups() {
      const map = {}
      this.simplifyHisFeeInfo.feeDetails.forEach(fee => {
        const feeName = fee.feeName || '其他费用'
        const payerName = fee.payerObjName || ''
        // 车辆类费用按车辆名称再分组，房屋类费用只按费用名称分组
        const isVehicle = /车辆|停车|车位/.test(feeName)
        const groupKey = isVehicle ? `${feeName}||${payerName}` : feeName
        const displayName = isVehicle ? `${feeName} - ${payerName}` : feeName
        if (!map[groupKey]) {
          map[groupKey] = { displayName, fees: [] }
        }
        map[groupKey].fees.push(fee)
      })
        const result = Object.values(map).map(group => {
        group.fees.sort((a, b) => {
          const tA = a.startTime ? new Date(a.startTime).getTime() : 0
          const tB = b.startTime ? new Date(b.startTime).getTime() : 0
          return tA - tB
        })
        return { feeName: group.displayName, fees: group.fees }
      })
      return result
    }
  },
  created() {
    this.communityId = getCommunityId()
  },
  methods: {
    open(param) {
      this.handleSwitch(param)
    },
    handleSwitch(param) {
      this.clearSimplifyHisFeeInfo()
      // 必须有业主、房屋或车辆ID
      if (!param.ownerId && !param.roomId && !param.carId) {
        return
      }
      Object.assign(this.simplifyHisFeeInfo, param)
      // 优先按当前对象查询：先车辆，再房屋（含绑定车辆），最后才按业主
      if (param.carId) {
        // 指定车辆：只查该车辆缴费记录
        this._loadCarFeeDetails()
      } else if (param.roomId) {
        // 指定房屋：只查该房屋及绑定车辆的缴费记录
        this._loadRoomAndCarFeeDetails()
      } else if (param.ownerId) {
        // 仅业主总览：查询该业主所有缴费记录
        this._listSimplifyFeeDetails(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
      }
    },
    handleNotify() {
      // 优先按当前对象刷新
      if (this.simplifyHisFeeInfo.carId) {
        this._loadCarFeeDetails()
      } else if (this.simplifyHisFeeInfo.roomId) {
        this._loadRoomAndCarFeeDetails()
      } else if (this.simplifyHisFeeInfo.ownerId) {
        this._listSimplifyFeeDetails(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
      }
    },
    async _loadCarFeeDetails() {
      try {
        // 指定车辆：只查该车辆缴费记录
        if (this.simplifyHisFeeInfo.carId) {
          const feeRes = await queryFeeDetail({
            page: 1,
            row: 500,
            communityId: this.communityId,
            payerObjId: this.simplifyHisFeeInfo.carId,
            payerObjType: '6666'
          })
          this.simplifyHisFeeInfo.feeDetails = (feeRes.data && feeRes.data.feeDetails) || []
          return
        }

        // 指定房屋：查房屋本身 + 该房屋绑定的各车辆缴费记录
        if (!this.simplifyHisFeeInfo.roomId) {
          this.simplifyHisFeeInfo.feeDetails = []
          return
        }

        const allDetails = []
        const detailIdSet = new Set()

        // 1. 房屋缴费记录
        const roomFeeRes = await queryFeeDetail({
          page: 1,
          row: 500,
          communityId: this.communityId,
          payerObjId: this.simplifyHisFeeInfo.roomId,
          payerObjType: '3333'
        })
        const roomDetails = (roomFeeRes.data && roomFeeRes.data.feeDetails) || []
        roomDetails.forEach(item => {
          if (!detailIdSet.has(item.detailId)) {
            detailIdSet.add(item.detailId)
            allDetails.push(item)
          }
        })

        // 2. 绑定车辆的缴费记录
        const carRes = await queryOwnerCars({
          page: 1,
          row: 50,
          roomId: this.simplifyHisFeeInfo.roomId,
          communityId: this.communityId
        })
        const cars = (carRes.data && carRes.data.data) || []
        for (const car of cars) {
          const feeRes = await queryFeeDetail({
            page: 1,
            row: 500,
            communityId: this.communityId,
            payerObjId: car.carId,
            payerObjType: '6666'
          })
          const carDetails = (feeRes.data && feeRes.data.feeDetails) || []
          carDetails.forEach(item => {
            if (!detailIdSet.has(item.detailId)) {
              detailIdSet.add(item.detailId)
              allDetails.push(item)
            }
          })
        }

        this.simplifyHisFeeInfo.feeDetails = allDetails
      } catch (error) {
        console.error('加载车辆缴费记录失败', error)
        this.simplifyHisFeeInfo.feeDetails = []
      }
    },
    async _loadRoomAndCarFeeDetails() {
      try {
        const allDetails = []
        const detailIdSet = new Set()

        // 1. 房屋缴费记录
        const roomFeeRes = await queryFeeDetail({
          page: 1,
          row: 500,
          communityId: this.communityId,
          payerObjId: this.simplifyHisFeeInfo.roomId,
          payerObjType: '3333'
        })
        const roomDetails = (roomFeeRes.data && roomFeeRes.data.feeDetails) || []
        roomDetails.forEach(item => {
          if (!detailIdSet.has(item.detailId)) {
            detailIdSet.add(item.detailId)
            allDetails.push(item)
          }
        })

        // 2. 绑定车辆缴费记录
        const carRes = await queryOwnerCars({
          page: 1,
          row: 50,
          roomId: this.simplifyHisFeeInfo.roomId,
          communityId: this.communityId
        })
        const cars = (carRes.data && carRes.data.data) || []
        for (const car of cars) {
          const feeRes = await queryFeeDetail({
            page: 1,
            row: 500,
            communityId: this.communityId,
            payerObjId: car.carId,
            payerObjType: '6666'
          })
          const carDetails = (feeRes.data && feeRes.data.feeDetails) || []
          carDetails.forEach(item => {
            if (!detailIdSet.has(item.detailId)) {
              detailIdSet.add(item.detailId)
              allDetails.push(item)
            }
          })
        }

        this.simplifyHisFeeInfo.feeDetails = allDetails
      } catch (error) {
        console.error('加载房屋及车辆缴费记录失败', error)
        this.simplifyHisFeeInfo.feeDetails = []
      }
    },
    formatDate(date) {
      if (!date) return ''
      return dateFormat(date)
    },
    _listSimplifyFeeDetails(page, row) {
      const params = {
        page,
        row,
        communityId: this.communityId,
        ownerId: this.simplifyHisFeeInfo.ownerId
      }

      queryFeeDetail(params)
        .then(response => {
          const res = response.data
          this.simplifyHisFeeInfo.feeDetails = res.feeDetails
        })
        .catch(error => {
          console.error('请求失败处理', error)
        })
    },
    clearSimplifyHisFeeInfo() {
      this.simplifyHisFeeInfo = {
        feeDetails: [],
        ownerId: '',
        roomId: '',
        feeDetail: {},
        receiptType: 'Y',
        receiptCode: ''
      }
    },
    _toHisFeeDetail(detail) {
      this.$emit('viewFeeDetail', detail)
    },
    _openGeneratorReceiptCode(detail) {
      this.simplifyHisFeeInfo.feeDetail = detail
      this.receiptDialogVisible = true
    },
    _generatorReceiptCode() {
      const data = {
        detailId: this.simplifyHisFeeInfo.feeDetail.detailId,
        communityId: this.communityId,
        receiptCode: this.simplifyHisFeeInfo.receiptCode
      }

      generatorReceipt(data)
        .then(response => {
          const res = response.data
          this.$message.success(res.msg)
          if (res.code !== 0 && res.code !== '0') {
            return
          }
          this.receiptDialogVisible = false
          // 直接刷新列表，不再依赖父组件的@doSearch（父组件并未监听此事件）
          // 优先按当前对象刷新，避免业主总览混入其他房屋记录
          if (this.simplifyHisFeeInfo.carId) {
            this._loadCarFeeDetails()
          } else if (this.simplifyHisFeeInfo.roomId) {
            this._loadRoomAndCarFeeDetails()
          } else if (this.simplifyHisFeeInfo.ownerId) {
            this._listSimplifyFeeDetails(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
          }
        })
        .catch(error => {
          console.error('请求失败处理', error)
          this.$message.error(error.message || '操作失败')
        })
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
.w-100 {
  width: 100%;
}

.fee-group {
  margin-bottom: 12px;
}

.group-title {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  padding: 6px 0;
  margin-bottom: 2px;
  border-bottom: 2px solid #409EFF;
}

.no-data-tip {
  text-align: center;
  color: #909399;
  padding: 30px 0;
  font-size: 13px;
}
</style>